var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "dg-contextmenu vue-contextmenu-listWrapper",
      class: "vue-contextmenuName-" + _vm.contextMenuData.menuName,
      on: {
        contextmenu: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    _vm._l(_vm.contextMenuData.menulists, function (item) {
      return _c("li", { key: item.btnName, staticClass: "context-menu-list" }, [
        item.children && item.children.length > 0
          ? _c(
              "div",
              { staticClass: "has-child" },
              [
                _c(
                  "div",
                  {
                    staticClass: "parent-name btn-wrapper-simple",
                    class: {
                      "no-allow": item.disabled ? item.disabled : false,
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "nav-icon-fontawe",
                      class: item.icoName ? item.icoName : "",
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "nav-name-right" }, [
                      _vm._v(_vm._s(item.btnName)),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "icon" }),
                  ]
                ),
                _vm._v(" "),
                _c("Tree", {
                  attrs: {
                    itemchildren: item.children,
                    float: _vm.floatDirection,
                  },
                  on: { childhandler: _vm.fnHandler },
                }),
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "no-child-btn btn-wrapper-simple",
                  class: { "no-allow": item.disabled ? item.disabled : false },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      item.disabled === true ? "" : _vm.fnHandler(item, $event)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "nav-icon-fontawe",
                    class: item.icoName ? item.icoName : "",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-name-right" }, [
                    _vm._v(_vm._s(item.btnName)),
                  ]),
                ]
              ),
            ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }